import { SET_AUDIO_ONLY } from '../../../../react/features/base/audio-only/actionTypes';
import MiddlewareRegistry from '../../../../react/features/base/redux/MiddlewareRegistry';
import { setStorageData } from '../../../functions.any';
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case SET_AUDIO_ONLY: {
            const { audioOnly } = action;
            const { room } = store.getState()['features/base/conference'];
            if (room) {
                setStorageData('wildix/features/audio-only', String(audioOnly));
            }
            break;
        }
    }
    return next(action);
});
